import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    bar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box",
      backgroundColor: theme.goal.balanceSyncBanner.background,
      paddingLeft: constants.divPadding,
      paddingRight: constants.divPadding,
      paddingTop: spacing.m,
      paddingBottom: spacing.m,
      borderRadius: constants.radius.view,
      cursor: "pointer",
    },
    textColumn: {
      marginLeft: spacing.m,
      flexShrink: 1,
    },
    line: {
      display: "block",
      fontWeight: 500,
    },
  };

  return styles;
};
